import "core-js/modules/es.array.push.js";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
import { backlogTypeMap } from "../../util/type";
import { isPhoneNumber, phoneDesc, EncryptName } from "../../util/index";
import { useMainStore } from "../../pinia/main";
import { ElMessage } from "element-plus";
export default {
  name: "backlog",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      page: 1,
      //当前页数
      size: 10,
      //一页几条
      total: 0,
      //共几条
      pages: 0,
      //一共几页
      list: []
    });
    onMounted(() => {
      selectAgendaList();
    });
    const selectAgendaList = async () => {
      const params = {
        page: data.page,
        size: data.size
      };
      const res = await globalProperties.$api.selectAgendaList(params);
      if (res) {
        data.list = res.records;
        data.page = res.current;
        data.size = res.size;
        data.total = res.total;
        data.pages = res.pages;
      }
    };
    const reset = () => {
      data.page = 1;
      data.size = 10;
      data.list = [];
      selectAgendaList();
    };
    const currentChange = page => {
      data.page = page;
      selectAgendaList();
    };

    //接受他人变更车辆 是否同意 0->否 1->是
    const handleAcceptChangeDriver = async (agendaId, relevanceId, status) => {
      await globalProperties.$api.accomplishAgenda(agendaId);
      await globalProperties.$api.acceptChangeDriver({
        relevanceId: relevanceId,
        status: status
      });
      ElMessage.success("操作成功");
      reset();
    };

    //托运人-承运人-同意取消订单
    const agreeCancelOrder = async (record, status) => {
      const {
        agendaId,
        orderInfo
      } = record;
      await globalProperties.$api.accomplishAgenda(agendaId);
      await globalProperties.$api.acceptChangeDriver({
        orderId: orderInfo.orderId,
        status
      });
      ElMessage.success("操作成功");
      reset();
    };

    //查看订单详情
    const viewOrderDetail = async record => {
      const {
        agendaId,
        orderInfo
      } = record;
      await globalProperties.$api.accomplishAgenda(agendaId);
      router.push({
        path: "/layout/orderdetail",
        query: {
          orderId: orderInfo.orderId
        }
      });
    };
    //查看开票管理
    const viewInvoiceManage = async record => {
      const {
        agendaId
      } = record;
      await globalProperties.$api.accomplishAgenda(agendaId);
      mainStore.setTabIndex("3");
      router.replace("/layout/invoice");
    };
    return {
      data,
      backlogTypeMap,
      isPhoneNumber,
      phoneDesc,
      viewInvoiceManage,
      EncryptName,
      currentChange,
      handleAcceptChangeDriver,
      viewOrderDetail,
      agreeCancelOrder
    };
  }
};